import { useState, useContext } from "react";
import traking from "../../../lib/event/tracker";
import styles from "./index.module.css";

import { ThemeContext } from "../../../contexts/theme";

const BurgerMenu = ({ isOpen, setIsOpen }) => {
  const theme = useContext(ThemeContext);

  const [isHover, setIsHover] = useState(false);

  const handleClick = () => {
    setIsOpen((e) => !e);
    traking({ eventAction: "click", eventName: "burgerMenu" });
  };

  return (
    <div
      className={styles.burger}
      onClick={handleClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        style={{
          background: theme.color,
          width: isHover ? "100%" : "100%",
        }}
        className={isOpen ? styles.closeLine : styles.line}
      ></div>
      <div
        style={{
          background: theme.color,
          width: isHover ? "100%" : "50%",
        }}
        className={isOpen ? styles.closeLine : styles.line}
      ></div>
      <div
        style={{
          background: theme.color,
          width: isHover ? "100%" : "80%",
        }}
        className={isOpen ? "" : styles.line}
      ></div>
    </div>
  );
};

export default BurgerMenu;
